import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=713ea389&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=713ea389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ea389",
  null
  
)

export default component.exports